import { Laya } from "../../../../Laya";
import { LayaGL } from "../../../layagl/LayaGL";
import { WebGLSetRenderData, WebGLSetShaderDefine } from "../RenderDevice/WebGLRenderCMD";
import { WebGLBlit2DQuadCMD, WebGLDraw2DElementCMD, WebGLSetRendertarget2DCMD } from "./WebGL2DRenderCMD";
import { WebglRenderContext2D } from "./WebGLRenderContext2D";
import { WebGLRenderelement2D } from "./WebGLRenderElement2D";
export class WebGLRender2DProcess {
    constructor() {
    }
    createSetRenderDataCMD() {
        return new WebGLSetRenderData();
    }
    createSetShaderDefineCMD() {
        return new WebGLSetShaderDefine();
    }
    createBlit2DQuadCMDData() {
        return new WebGLBlit2DQuadCMD();
    }
    createDraw2DElementCMDData() {
        return new WebGLDraw2DElementCMD();
    }
    createSetRendertarget2DCMD() {
        return new WebGLSetRendertarget2DCMD();
    }
    createRenderElement2D() {
        return new WebGLRenderelement2D();
    }
    createRenderContext2D() {
        return new WebglRenderContext2D();
    }
}
Laya.addBeforeInitCallback(() => {
    if (!LayaGL.render2DRenderPassFactory)
        LayaGL.render2DRenderPassFactory = new WebGLRender2DProcess();
});
